// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Dwd","col":"styles_col__FY14Z"};